import React from "react";
import { CenteredSiteBlock } from "../../routes/Home";
import { Box, styled, Typography, useMediaQuery } from "@mui/material";
import { useIsMobile } from "../../hooks/responsive";
import RainbowDivider from "../misc/RainbowDivider";
import PodcastsList from "./podcasts/PodcastsList";
import PraticiansPodcasts from "../podcastsSection/PraticiansPodcasts";

import logoImage from "../../resources/images/svg/inexplore-logo-white.svg";
import TVCard from "./podcasts/TVCard";
import InexButton from "../InexButton";

const Container = styled(Box)(({ theme }) => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    width: "100%",
    minHeight: "100px",
    backgroundColor: theme.palette.blackPro,
    position: "relative",
  };
});


const redirectToSubscribe = () => {
	window.open(`https://abonnements.inexplore.com/je-mabonne?selectedAbos=[3,4]`, "_blank").focus();
};

const Podcasts = ({}) => {
  const isMobile = useIsMobile();

  return (
    <Container className={"develop-alliances"}>
      <CenteredSiteBlock
        sx={{
          position: "relative",
          backgroundRepeat: "no-repeat",
          backgroundSize: "stretch",
          backgroundPosition: "top",
          marginTop: (theme) => theme.spacing(isMobile ? 5 : 5),
          marginBottom: (theme) => theme.spacing(isMobile ? 5 : 10),
          display: "flex",
          flexDirection: "column",
          paddingLeft: "20px",
          paddingRight: "20px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            mb: 5,
          }}
        >
          <Typography
            variant={"h2"}
            sx={{
              color: "white",
            }}
          >
            Chaque mercredi sur
          </Typography>
          <img src={logoImage} alt={"site logo"} style={{ width: "100%" }} />
        </Box>
        <PraticiansPodcasts limitPublic={4} />
        <TVCard />

        <InexButton
          text={"Je m'abonne pour en profiter"}
          variant={"text"}
          textWithGradient={false}
          onClick={redirectToSubscribe}
          sx={{
            zIndex: 1,
            marginBottom: 2,
            p: 3,
            marginTop: 5,
            width: "300px",
            height: "50px",
            background: (theme) => theme.palette.primary.main,
            border: (theme) => theme.palette.primary.main + " solid 3px",
            color: "white",
            "&:hover": {
              backgroundColor: "white",
              "& > p": {
                color: (theme) => theme.palette.primary.main,
              },
            },
          }}
        />

      </CenteredSiteBlock>
      <RainbowDivider />
    </Container>
  );
};

export default Podcasts;
